import * as React from "react";
import { useContext, useRef, useState } from "react";
import styled from "styled-components";
import { SEARCH_BAR_GAP } from "views/components/searchbar/SearchBarLayout";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import TimeRangeFilterSettingsContext from "views/components/contexts/TimeRangeInputSettingsContext";
import TimeRangePicker from "views/components/time-range-picker/index";
import { NO_TIMERANGE_OVERRIDE } from "views/Constants";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import MoveRange from "views/components/searchbar/time-range-filter/MoveRange";
import TimeRangeDisplay from "views/components/time-range-picker/TimeRangeDisplay";
import TimeRangeFilterButtons from "./TimeRangeFilterButtons";
const FlexContainer = styled.div`
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  flex: 1;
  min-width: 430px;
  gap: ${SEARCH_BAR_GAP};
  position: relative;
`;
const RightCol = styled.div`
  display: flex;
  width: 100%;
`;
const TimeRangeFilter = ({
  disabled = false,
  hasErrorOnMount = false,
  noOverride = false,
  value = NO_TIMERANGE_OVERRIDE,
  onChange,
  validTypes = void 0,
  position = "bottom-start",
  className = void 0,
  showPresetDropdown = true,
  limitDuration,
  withinPortal = true,
  submitOnPresetChange = true,
  moveRangeProps = void 0
}) => {
  const containerRef = useRef();
  const { showDropdownButton } = useContext(TimeRangeFilterSettingsContext);
  const sendTelemetry = useSendTelemetry();
  const [show, setShow] = useState(false);
  if (validTypes && value && "type" in value && !validTypes.includes(value == null ? void 0 : value.type)) {
    throw new Error(`Value is of type ${value.type}, but only these types are valid: ${validTypes}`);
  }
  const toggleShow = () => {
    setShow(!show);
    sendTelemetry(TELEMETRY_EVENT_TYPE.SEARCH_TIMERANGE_PICKER_TOGGLED, {
      app_section: "search-bar",
      app_action_value: "time-range-picker",
      event_details: {
        showing: !show
      }
    });
  };
  const hideTimeRangeDropDown = () => show && toggleShow();
  return /* @__PURE__ */ React.createElement(
    TimeRangePicker,
    {
      show,
      currentTimeRange: value,
      limitDuration,
      noOverride,
      setCurrentTimeRange: onChange,
      toggleDropdownShow: toggleShow,
      validTypes,
      position,
      withinPortal
    },
    /* @__PURE__ */ React.createElement(FlexContainer, { className, ref: containerRef }, showDropdownButton && /* @__PURE__ */ React.createElement(
      TimeRangeFilterButtons,
      {
        limitDuration,
        disabled,
        toggleShow,
        onPresetSelectOpen: hideTimeRangeDropDown,
        setCurrentTimeRange: onChange,
        showPresetDropdown,
        hasErrorOnMount,
        submitOnPresetChange
      }
    ), /* @__PURE__ */ React.createElement(RightCol, null, /* @__PURE__ */ React.createElement(
      MoveRange,
      {
        displayMoveRangeButtons: !!moveRangeProps,
        setCurrentTimeRange: onChange,
        initialTimerangeFormat: moveRangeProps == null ? void 0 : moveRangeProps.initialTimerangeFormat,
        effectiveTimerange: moveRangeProps == null ? void 0 : moveRangeProps.effectiveTimerange,
        initialTimerange: moveRangeProps == null ? void 0 : moveRangeProps.initialTimerange,
        currentTimerange: value
      },
      /* @__PURE__ */ React.createElement(TimeRangeDisplay, { timerange: value, toggleDropdownShow: toggleShow })
    )))
  );
};
export default TimeRangeFilter;
